import { render, staticRenderFns } from "./GaleriDetay.vue?vue&type=template&id=e83cdfce&scoped=true&"
import script from "./GaleriDetay.vue?vue&type=script&lang=js&"
export * from "./GaleriDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83cdfce",
  null
  
)

export default component.exports